import React, { useState } from 'react';
import ProjectContext from '.';
import { AllProject } from '../../Data/Project';

const ProjectProvider = (props) => {
  const [allProject, setAllProject] = useState(AllProject);
  const addNewProject = (project) => {
    const tempObj = {
      id: allProject.length + 1,
      title: project.project_title,
      badge: 'Doing',
      img: 'user/3.jpg',
      sites: 'Themeforest, australia',
      issue: <div className='font-secondary col-6'>40</div>,
      resolved: <div className='font-secondary col-6'>40</div>,
      comment: <div className='font-secondary col-6'>20</div>,
      desc: project.enter_some_details,
      like: project.project_rate,
      progress: 75,
      customers_img1: 'user/3.jpg',
      customers_img2: 'user/5.jpg',
      customers_img3: 'user/1.jpg',
    };
    setAllProject([...allProject, tempObj]);
  };
  return <ProjectContext.Provider value={{ ...props, allProject, addNewProject: addNewProject }}>{props.children}</ProjectContext.Provider>;
};

export default ProjectProvider;
